export const ID60 = () => {
    return (
        <div>
            <div className="content" readonly=""><h1>Эффективное решение для автоматизации крупного
                и&nbsp;среднего&nbsp;бизнеса на&nbsp;современной платформе «1С:Предприятие 8</h1><span
            ><br/></span>
                <div><span>«1С:ERP Управление предприятием» («1C:ERP») — это инновационное и эффективное решение от компании «1С» для создания комплексной информационной системы управления любым предприятием. Этот продукт позволяет автоматизировать основные бизнес-процессы, контролировать ключевые показатели деятельности предприятия, организовать взаимодействие служб и подразделений, координировать деятельность производственных подразделений, оценивать эффективность деятельности предприятия, отдельных подразделений и персонала.<br/><br/></span>
                </div>
                <div><span>«1C:ERP» был создан с учетом лучших мировых и отечественных практик автоматизации крупного и среднего бизнеса, а также при непосредственном участии представителей крупных промышленных предприятий. Благодаря экспертному подходу к разработке и поэтапному тестированию «1C:ERP» получил именно те функциональные возможности, которые наиболее востребованы в крупных предприятиях с различными направлениями деятельности, в том числе в технически сложных многопередельных производствах.</span>
                </div>
                <h2><br/></h2><h2>

                    Для чего используют&nbsp;«1C:ERP»?</h2><h2><span>Начиная с 2014 года свыше 9000 предприятий стали клиентами «1С:ERP Управление предприятием»:</span>
                </h2>
                <h3 data-contents="dlya_chego_ispolzuyut_1c_erp_"
                >
                    <ul>
                        <li>для оптимизации процесса производства, составления
                            достоверного графика деятельности с учетом загрузки оборудования и обеспечения ресурсами;
                        </li>
                        <li>при переходе от морально устаревших разрозненных
                            систем управления – чтобы организовать эффективную работу в едином информационном
                            пространстве;
                        </li>
                        <li>для простого и удобного отслеживания ключевых
                            показателей работы предприятия на всех уровнях управления;
                        </li>
                        <li>для согласованной работы служб предприятия при
                            построении и исполнении планов продаж, производства и закупок;
                        </li>
                        <li>чтобы внедрить эффективную систему управления
                            денежными средствами, выработать оптимальные способы достижения финансовых целей компании;
                        </li>
                        <li>чтобы повысить эффективность работы коммерческих и
                            логистических служб, улучшить качество обслуживания клиентов, повысить точность и
                            оперативность получения информации;
                        </li>
                        <li><span>для получения достоверных данных о деятельности предприятия, себестоимости и выручке в разрезе требуемых аналитик.</span>
                        </li>
                    </ul>
                </h3>
                <h2>
                    Экономический эффект от&nbsp;внедрения ERP-систем «1С»</h2>
                <div>Используя «1С:ERP» на своем предприятии, вы получаете комплексную информационную систему
                    управления, которая обеспечит своевременное принятие управленческих решений, прозрачность
                    бизнес-процессов и оценку эффективности деятельности предприятия, отдельных подразделений и
                    персонала. Процентные показатели роста конкурентных преимуществ и экономического эффекта от
                    внедрения ERP-решений на платформе «1С:Предприятие 8» представлены ниже.<br/></div>
                <div><br/></div>
                <div>
                    <table>
                        <thead>
                        <tr>
                            <th>Показатель эффективности
                            </th>
                            <th>Проекты до 199 АРМ
                            </th>
                            <th>Проекты от 200 АРМ
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td rowSpan="5">
                                <span>Эффективность и оперативность</span>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>Рост прибыли</span>
                            </td>
                            <td>
                                <span>13%</span>
                            </td>
                            <td>
                                <span>8%</span>
                            </td>
                        </tr>
                        <tr>
                            <td>Ускорение обработки заказов</td>
                            <td>46%</td>
                            <td>42%</td>
                        </tr>
                        <tr>
                            <td>Сокращение
                                сроков исполнения заказов
                            </td>
                            <td>22%</td>
                            <td>23%</td>
                        </tr>
                        <tr>
                            <td>Сокращение
                                операционных и административных расходов
                            </td>
                            <td>16%</td>
                            <td>13%</td>
                        </tr>
                        <tr>
                            <td rowSpan="8"
                            >
                                <span>Запасы и производство</span>
                            </td>
                            <td>Снижение
                                объемов материальных запасов
                            </td>
                            <td>18%</td>
                            <td>15%</td>
                        </tr>
                        <tr>
                            <td>Сокращение
                                расходов на материальные ресурсы
                            </td>
                            <td>15%</td>
                            <td>12%</td>
                        </tr>
                        <tr>
                            <td>Снижение
                                производственных издержек
                            </td>
                            <td>15%</td>
                            <td>13%</td>
                        </tr>
                        <tr>
                            <td>Снижение
                                себестоимости выпускаемой продукции
                            </td>
                            <td>9%</td>
                            <td>8%</td>
                        </tr>
                        <tr>
                            <td>Увеличение
                                объема выпускаемой продукции
                            </td>
                            <td>23%</td>
                            <td>16%</td>
                        </tr>
                        <tr>
                            <td>Рост
                                производительности труда в производстве
                            </td>
                            <td>21%</td>
                            <td>17%</td>
                        </tr>
                        <tr>
                            <td>Сокращение
                                длительности простоев оборудования
                            </td>
                            <td>23%</td>
                            <td>13%</td>
                        </tr>
                        <tr>
                            <td>Снижение
                                производственного брака
                            </td>
                            <td>17%</td>
                            <td>19%</td>
                        </tr>
                        <tr>
                            <td rowSpan="2"
                            >
                                <span>Оборотные средства</span>
                            </td>
                            <td>Рост
                                оборачиваемости складских запасов
                            </td>
                            <td>23%</td>
                            <td>16%</td>
                        </tr>
                        <tr>
                            <td>Сокращение
                                дебиторской задолженности
                            </td>
                            <td>14%</td>
                            <td>15%</td>
                        </tr>
                        <tr>
                            <td rowSpan="3"
                            >
                                <span>Трудозатраты и отчетность</span>
                            </td>
                            <td>Сокращение
                                трудозатрат в различных подразделениях
                            </td>
                            <td>22%</td>
                            <td>21%</td>
                        </tr>
                        <tr>
                            <td>Ускорение
                                получения управленческой отчетности
                            </td>
                            <td>В
                                2&nbsp;раза
                            </td>
                            <td>59%</td>
                        </tr>
                        <tr>
                            <td>Ускорение
                                подготовки регламентированной отчетности
                            </td>
                            <td>59%</td>
                            <td>58%</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}